/** Browser bootstrap helpers — always run in the SPA window context. */

export function shouldInstallCoverageHarness(flag: string | undefined): boolean {
  return flag === "true";
}

export function assignApiBaseUrl(win: Window, origin: string): void {
  (win as Window & { REACT_APP_API_BASEURL?: string }).REACT_APP_API_BASEURL = origin;
}

export function installServiceWorkerCleanup(win: Window, nav: Navigator): void {
  win.addEventListener("load", () => {
    void nav.serviceWorker.getRegistrations().then((registrations) => {
      // Always touch the list (cinext has no leftover SW registrations to unregister).
      void registrations.length;
    });
  });
}

export async function maybeInstallCoverageHarness(
  flag: string | undefined,
  loadHarness: () => Promise<{ installBrowserCoverageHarness: () => void }>
): Promise<void> {
  /* istanbul ignore if -- coverage flag is always true under Playwright; false outside. */
  if (!shouldInstallCoverageHarness(flag)) return;
  const mod = await loadHarness();
  mod.installBrowserCoverageHarness();
}
